<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Refund Receipt</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="BillData2">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BillData2.PrescriberName}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Bill Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Bill No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{BillNo}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Referred By:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{ReferralData}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          #
                        </th>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Item Description
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Prescriber
                        </th>-->
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family width-35px">
                          Qty
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Price
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Amount
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Disc(%)
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Tax
                        </th>-->
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-75">
                          Net Refundable
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.ItemDescription}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.PrescriberName}}</td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.Quantity}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.ItemTotal | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.Discount | number:'1.2-2'}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">0.00</td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{RefundData | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-7 float-right">
              <label class="margin-bottom-0px font-family font-weight-bold float-right">Bill Summary:</label>
            </div>
            <div class="col-print-1">

            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Grand Total:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{GrandTotal}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discount:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Discount}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Tax:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Tax}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Net:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Net}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Payment Details:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-left">
                          #
                        </th>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Rec.No & Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Pay Mode
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Amount
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillReceiptsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.BillFormattedCode}} &amp; {{l.ReceiptDate | date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.PaymentInstrument}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.AmountPaid | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.Remarks}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal">Cashier:</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <!--<div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">(</label>
            </div>-->
            <div class="col-print-5" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family font-weight-normal">( {{CurrentX_BillHeaderController.PayeeName}} )</label>
            </div>
            <!--<div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">)</label>
            </div>-->
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Due:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Due}}</label>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
